import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { InstallPrompt } from "@/components/InstallPrompt";
import { ProfileProvider } from "@/context/ProfileContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import StreamCalculator from "@/pages/StreamCalculator";
import StreamResult from "@/pages/StreamResult";
import SharedReport from "@/pages/SharedReport";
import Admin from "@/pages/Admin";
import Draws from "@/pages/Draws";
import StreamMatrix from "@/pages/StreamMatrix";
import RulesEngine from "@/pages/RulesEngine";
import Methodology from "@/pages/Methodology";
import Privacy from "@/pages/Privacy";
import Unsubscribe from "@/pages/Unsubscribe";

function App() {
  return (
    <ProfileProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/results" element={<Results />} />
            <Route path="/calculator" element={<StreamCalculator />} />
            <Route path="/stream-result" element={<StreamResult />} />
            <Route path="/s/:code" element={<SharedReport />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/draws" element={<Draws />} />
            <Route path="/streams" element={<StreamMatrix />} />
            <Route path="/rules" element={<RulesEngine />} />
            <Route path="/methodology" element={<Methodology />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors />
        <InstallPrompt />
      </BrowserRouter>
    </ProfileProvider>
  );
}

export default App;
